import React, { useState, useEffect } from 'react';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';
import NovaModalidadeColeta from './NovaModalidadeColeta';

//Api
import modalidadeColeta_api from '../../../api/modalidadeColeta_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

export default function ModalidadeColeta({ permissao }) {
    //Variavel que guarda as ações da tabela
    const actions = [];
    if (permissao === "Editar")
        actions.push(actionsTable.editar((item) => setEditarModalidade(item.id)));

    //Estado que guarda a lista de modalidades
    const [modalidades, setModalidades] = useState([]);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle da tela de cadastro de nova modalidade
    const [novaModalidade, setNovaModalidade] = useState(false);

    //Estado de controle da tela de edição de uma modalidade
    const [editarModalidade, setEditarModalidade] = useState(null);

    //Cabeçalhos da tabela de listagem de modalidades
    const headers = [
        { value: "Descrição", objectValue: "descricao", align: "left" },
        { value: "Ativo", objectValue: "ativo", align: "left" },
        { value: "Tirar foto da coleta", objectValue: "foto", trueValue: "Sim", falseValue: "Não", align: "left" },
        { value: "Unidade de medida", objectValue: "volumetrias", align: "left" },
        { value: "Tipo de residuo", objectValue: "residuos", align: "left" },
        {
            value: "PGRS Obrigatório", objectValue: "pgrsObrigatorio", align: "left", options: {
                filter: false,
                customBodyRenderLite: (dataIndex) => {
                    return <>{modalidades[dataIndex].pgrsObrigatorio ? "Sim" : "Não"}</>
                }
            }
        }
    ]

    //Carrega a listagem de modalidades
    const loadModalidades = () => {
        modalidadeColeta_api.GetList().then(response => {
            response.data = response.data.map(value => { return { ...value, foto: value.foto ? "Sim" : "Não" } })
            setModalidades(response.data);
            setLoading(false);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
            setLoading(false);
        });
    }

    //Carrega as modalidades
    useEffect(() => {
        setLoading(true);
        loadModalidades();
    }, []);

    //Controle da apresentação da tela de nova modalidade
    if (novaModalidade) {
        return <NovaModalidadeColeta loading={loading} setLoading={setLoading} btnVoltar={() => {
            loadModalidades();
            setNovaModalidade(false);
        }} />
    }
    //Controle da apresentação da tela de editar a modalidade
    if (editarModalidade) {
        return <NovaModalidadeColeta id={editarModalidade} loading={loading} setLoading={setLoading} btnVoltar={() => {
            loadModalidades();
            setEditarModalidade(false);
        }} />
    }
    return (
        <>
            {loading && <Loading />}
            <MainCard noCard btnCadastro={permissao === "Editar" ? "Adicionar" : null} onClickBtnCadastro={() => setNovaModalidade(true)}>
                <div className="mt-4">
                    <TabelaListagem headers={headers} items={modalidades} actions={actions} title={"Lista de modalidades"} options={{ print: false, search: true, pagination: true }} />
                </div>
            </MainCard>
        </>
    )
}